import React from "react";

const getIcon = (title) => {
  const t = title?.toLowerCase() || "";
  if (t.includes("pending")) return "⏳";
  if (t.includes("customer")) return "👥";
  if (t.includes("profit")) return "📈";
  if (t.includes("purchase")) return "🛒";
  if (t.includes("sale")) return "💰";
  return "📊";
};

const Dash = ({ title, value }) => {
  const icon = getIcon(title);
  const isSelected = value !== undefined && value !== null && value !== "" && value !== false;

  return (
    <div
      className={`rounded-2xl p-4 transition-all duration-200 border text-left flex flex-col justify-between h-full group ${
        isSelected
          ? "bg-white border-emerald-500 shadow-md ring-2 ring-emerald-500/20"
          : "bg-white border-slate-200/80 shadow-xs hover:shadow-md hover:border-slate-300"
      }`}
    >
      <div className="flex items-center justify-between gap-2 mb-2">
        <span className="text-[10px] font-extrabold text-slate-400 uppercase tracking-wider">
          Total Metric
        </span>
        <span className="text-xl p-1.5 rounded-xl bg-slate-100 group-hover:scale-110 transition-transform">
          {icon}
        </span>
      </div>

      <div>
        <h3 className="text-xs sm:text-sm font-bold text-slate-700 group-hover:text-emerald-700 transition">
          {title}
        </h3>

        {isSelected ? (
          <div className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-mono tracking-tight mt-1">
            {value}
          </div>
        ) : (
          <div className="text-xs text-slate-400 font-medium mt-1">
            Click to view data
          </div>
        )}
      </div>

      <div className={`mt-3 h-1 w-full rounded-full transition-colors ${
        isSelected ? "bg-emerald-500" : "bg-slate-100 group-hover:bg-slate-200"
      }`} />
    </div>
  );
};

export default Dash;
